import React, { memo } from 'react';
import classNames from 'classnames';

import MaterialThumbnailPlaceholder from '../MaterialThumbnail/MaterialThumbnailPlaceholder';

const MaterialThumbnailGroupPlaceholder = ({ className, variant }) => (
  <div
    className={classNames(`relative w-full ${className}`, {
      'max-[1023px]:[-ms-overflow-style:none] max-[1023px]:overflow-x-scroll max-[1023px]:overflow-y-hidden max-[1023px]:pl-5 max-[1023px]:relative max-[1023px]:[scrollbar-width:none] max-[1023px]:w-screen lg:max-[1023px]:h-[45px] max-[1023px]:md:pl-[3.333vw] [&::-webkit-scrollbar]:max-[1023px]:hidden':
        variant === 'PDPSelectUpholsteryUI' ||
        variant === 'PDPSelectUpholsteryUI--quickview',
      'max-[1023px]:md:h-auto max-[1023px]:md:overflow-auto max-[1023px]:md:!p-0 max-[1023px]:md:w-auto':
        variant === 'PDPSelectUpholsteryUI--quickview',
    })}
    data-xc="MaterialThumbnailGroup"
  >
    <div
      className={classNames(
        'max-[1023px]:flex max-[1023px]:max-w-full lg:grid lg:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] lg:relative lg:z-0',
        {
          'max-[1023px]:md:grid max-[1023px]:md:grid-cols-[repeat(auto-fill,minmax(49px,1fr))] max-[1023px]:md:relative max-[1023px]:md:z-0':
            variant === 'PDPSelectUpholsteryUI--quickview',
        }
      )}
    >
      {[1, 2, 3, 4, 5, 6, 7, 8, 9].map(id => (
        <div
          className={classNames(
            'h-full w-full max-[1023px]:flex-shrink-0 max-[1023px]:h-[59px] max-[1023px]:min-w-[59px] max-[1023px]:w-[59px]',
            {
              'max-[1023px]:md:h-full max-[1023px]:md:min-w-[auto] max-[1023px]:md:w-full':
                variant === 'PDPSelectUpholsteryUI--quickview',
            }
          )}
          key={id}
        >
          <MaterialThumbnailPlaceholder />
        </div>
      ))}
    </div>
  </div>
);

export default memo(MaterialThumbnailGroupPlaceholder);
